// @ts-nocheck
export default {
  data() {
    return {
      sortings: {
        HospitalName: [
          undefined,
          { by: "hospital-name", icon: "▲", direction: "asc" },
          { by: "hospital-name", icon: "▼", direction: "desc" },
        ],
        DateAndTime: [
          undefined,
          { by: "date-time", icon: "▲", direction: "asc" },
          { by: "date-time", icon: "▼", direction: "desc" },
        ],
      },
      currentSortKey: "HospitalName",
      currentSortIndex: 0,
      listOrder: undefined,
    };
  },

  computed: {
    HospitalNameColumnSortingIcon() {
      if (this.currentSortKey === "HospitalName") {
        return this.sortings.HospitalName[this.currentSortIndex]?.icon || "▼▲";
      }
      return "▼▲";
    },
    DateAndTimeColumnSortingIcon() {
      if (this.currentSortKey === "DateAndTime") {
        return this.sortings.DateAndTime[this.currentSortIndex]?.icon || "▼▲";
      }
      return "▼▲";
    },
  },

  methods: {
    changeListOrder(key, callback) {
      if (this.currentSortKey === key) {
        this.updateCurrentSortingIndex(callback);
        return;
      }

      this.currentSortKey = key;
      this.currentSortIndex = 0;
      this.updateCurrentSortingIndex(callback);
    },
    updateCurrentSortingIndex(callback) {
      if (
        this.currentSortIndex ===
        this.sortings[this.currentSortKey].length - 1
      ) {
        this.currentSortIndex = 0;
        this.listOrder = this.sortings[this.currentSortKey][0];
        callback();
        return;
      }

      this.currentSortIndex++;
      this.listOrder =
        this.sortings[this.currentSortKey][this.currentSortIndex];
      return callback();
    },
  },
};
